

export interface CardsProps {
    title: string;
    price: number;
}

// const UserList : React.FC<CardsProps> = ({title,price})=>{
//     return (
//         <div>
//            <div>sdadasdasdas</div>
//         </div>
//     )
// }
//
// export default UserList;


export default function(props: CardsProps){
    return (
        <div>
            <h1>hello CardsProps</h1>
            <div>{props.title}</div>
            <div>{props.price}</div>
        </div>
    )
}


